module.exports = __webpack_public_path__ + "img/checkApp1.a05409ac.png";